import React, {useEffect, useRef} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Layer, Stage} from 'react-konva'
import {raise} from '../events'
import {mouseHandler, namespace, useAnimationFrame} from '../utils'
import {getGameManager} from '../game-manager'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles(() => ({
    surface: {
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        width: '100vw',
        height: '100vh',
    },
    ui: {
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
    }
}))

let state = {rocketSpeed: 0, height: 0, speed: 1}
let elements = []
let gameObjects = []
export function getGameObjects() {
    return gameObjects
}

function compareZ(a, b) {
    let az = a.z || 0
    let bz = b.z || 0
    return az - bz
}

export function compareElementZ(a, b) {
    let az = a?.Element?.z ?? 0
    let bz = b?.Element?.z ?? 0
    return az - bz
}

export function getState() {
    return state
}

let lastDraw = Date.now()
let realDt

export function getRealDt() {
    return realDt
}

export function GameSurface({...props}) {
    const stage = useRef()
    let now = Date.now()
    let dt = (now - lastDraw) / 1000
    realDt = dt
    dt = dt * state.speed
    lastDraw = now
    const classes = useStyles()
    useAnimationFrame((time) => {
        raise('update', time)
    })
    useEffect(() => {
        state.stage = stage.current
    })
    elements.length = 0
    gameObjects.sort(compareZ)
    for (let go of gameObjects) {
        go.sendMessage('draw', elements, dt)
    }
    raise('gameSurfaceElements', elements)
    elements.sort(compareElementZ)
    let ui = getGameManager().api.ui([])
    return (
        <div className={classes.surface}>
            <Stage
                {...mouseHandler('stage', undefined, true)}
                ref={stage}
                width={window.innerWidth}
                height={window.innerHeight}
            >
                <Layer>
                    {elements.map((element, index) => (
                        <element.Element
                            {...props}
                            {...element.props}
                            key={index}
                            state={state}
                            data={namespace(state)}
                        />
                    ))}
                </Layer>
            </Stage>
            {ui.length && <Box className={classes.ui}>
                {ui.map((Element, index) => (
                    <Element key={index}/>
                ))}
            </Box>}
        </div>
    )
}
